import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
  width: 100%;
  height: 100%;
  padding-top: 50px;
  gap: 42px;
  box-sizing: border-box;
  overflow: hidden;
  @media (max-width: 360px) {
    padding-top: 22px;
    gap: 24px;
  }
`;
